import { render, staticRenderFns } from "./GarageSalaryCreateOrUpdate.vue?vue&type=template&id=d72f0bce&"
import script from "./GarageSalaryCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./GarageSalaryCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./GarageSalaryCreateOrUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports